module.exports = __webpack_public_path__ + "fonts/roboto-v15-latin-regular.9f916e330c478bbfa2a0dd6614042046.eot?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.eot
// module id = 340
// module chunks = 6